export default __webpack_public_path__ + "media/icons/facebook-e60240c2.svg";